import { ReactNode, useEffect } from 'react'
import { useAuth0 } from '../../hooks/useAuth0'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * Route guard component that requires authentication
 * Redirects to Auth0 login if user is not authenticated
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect()
    }
  }, [isLoading, isAuthenticated, loginWithRedirect])

  if (isLoading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <p>Loading...</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null // Redirect in progress
  }

  return <>{children}</>
}
